import {Component} from "react";
import CampaignsPlatformNavigation from "./DependenciesNewNav";

class App extends Component {
    render() {
        return <CampaignsPlatformNavigation/>
    }
}

export default App;